const Asterisk = () => <span className="akoconf-text-red-600 akoconf-mr-0.5">*</span>

export default Asterisk;
